import axios from "axios";
import { authHeader } from "./headerConfig";
const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin/categories";

const addCategory = data => {
    return axios.post(API_ENDPOINT, data, {
        withCredentials: true,

        headers: {
            ...authHeader(),
        },
    });
};
const editCategoryImg = (data, id) => {
    return axios.post(`${API_ENDPOINT}/${id}/image`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
        },
    });
};
const editCategory = (data, id) => {
    return axios.put(`${API_ENDPOINT}/${id}`, data, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const getAllCategories = async (page = 1) => {
    const response = await axios.get(`${API_ENDPOINT}?page=${page}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });

    return response.data;
};
const deleteCategory = id => {
    return axios.delete(`${API_ENDPOINT}/${id}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
};
const getCategory = async id => {
    const response = await axios.get(`${API_ENDPOINT}/${id}`, {
        withCredentials: true,
        headers: {
            ...authHeader(),
            Accept: "application/json",
        },
    });
    return response;
};
const categoryServices = {
    addCategory,
    getAllCategories,
    deleteCategory,
    getCategory,
    editCategory,
    editCategoryImg,
};

export default categoryServices;
